import { render, staticRenderFns } from "./FollowUpDetails.vue?vue&type=template&id=186adef4&scoped=true"
import script from "./FollowUpDetails.vue?vue&type=script&lang=ts"
export * from "./FollowUpDetails.vue?vue&type=script&lang=ts"
import style0 from "./FollowUpDetails.vue?vue&type=style&index=0&id=186adef4&lang=scss"
import style1 from "./FollowUpDetails.vue?vue&type=style&index=1&id=186adef4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186adef4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('186adef4')) {
      api.createRecord('186adef4', component.options)
    } else {
      api.reload('186adef4', component.options)
    }
    module.hot.accept("./FollowUpDetails.vue?vue&type=template&id=186adef4&scoped=true", function () {
      api.rerender('186adef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/follow-ups/components/FollowUpDetails.vue"
export default component.exports